// src/modules/app-views/services/pages/Document/tabs/ParametersTab/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Card, Col, Row } from 'antd';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import translateX from 'utils/translateX';
import SimpleInput from 'components/SimpleComponents/SimpleInput';
import SimpleSelect from 'components/SimpleComponents/SimpleSelect';
import SimpleLoadingArea from 'components/SimpleComponents/SimpleLoadingArea';
import { useDocumentContext } from 'components/core/DocumentProvider';
import BusinessTipsCard from './components/BusinessTipsCard';
import PreChecklistCard from './components/PreChecklistCard';
import CommonProblemsCard from './components/CommonProblemsCard';
import SearchTermsCard from './components/SearchTermsCard';
import SuggestedToolsCard from './components/SuggestedToolsCard';
import ProcedureStepsCard from './components/ProcedureStepsCard';
import ReferencesCard from './components/ReferencesCard';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const ServicesParametersTab = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { data, loading, viewMode, refresh } = useDocumentContext() || {};

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const disabled = viewMode === 'view';

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="container" style={{ position: 'relative', minHeight: 120 }}>
      <SimpleLoadingArea name="serviceParameters" isFetching={loading} data={data} />

      {/* TAGS CARD */}
      <Card title={<div className="text-muted">{translateX('tags')}</div>}>
        <Row gutter={ROW_GUTTER}>
          <Col xs={24}>
            <SimpleSelect
              name="tags"
              label="tags"
              mode="tags"
              allowClear
            />
          </Col>
        </Row>
      </Card>

      {/* PROCEDURE OVERVIEW CARD */}
      <Card title={<div className="text-muted">{translateX('procedure_overview')}</div>}>
        <Row gutter={ROW_GUTTER}>
          <Col xs={24}>
            <SimpleInput name="procedureOverview" label="procedure_overview" type="textarea" rows={3} />
          </Col>
        </Row>
      </Card>

      {/* SUGGESTED TOOLS CARD */}
      <SuggestedToolsCard data={data} disabled={disabled} onRefresh={refresh} />

      {/* PRE-SERVICE CHECKLIST CARD */}
      <PreChecklistCard data={data} disabled={disabled} onRefresh={refresh} />

      {/* PROCEDURE STEPS CARD */}
      <ProcedureStepsCard data={data} disabled={disabled} onRefresh={refresh} />

      {/* COMMON PROBLEMS CARD */}
      <CommonProblemsCard data={data} disabled={disabled} onRefresh={refresh} />

      {/* BUSINESS TIPS CARD */}
      <BusinessTipsCard data={data} disabled={disabled} onRefresh={refresh} />

      {/* TECHNICAL REFERENCES CARD */}
      <ReferencesCard data={data} disabled={disabled} onRefresh={refresh} />

      {/* SEARCH TERMS CARD */}
      <SearchTermsCard />

      {/* NOTES CARD */}
      <Card title={<div className="text-muted">{translateX('notes')}</div>}>
        <Row gutter={ROW_GUTTER}>
          <Col xs={24}>
            <SimpleInput name="note" label="notes" type="textarea" rows={4} />
          </Col>
        </Row>
      </Card>
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ServicesParametersTab;

// *******************************************************************************
// HELPERS
// *******************************************************************************
